<div class="tooltip" [ngClass]="{'open-tooltip': tooltipAction, 'tooltip_position_right': position === 'right', 'tooltip_position_left': position === 'left'}">
    <div class="tooltip__trigger"></div>
    <div class="tooltip__content">
        {{ text }}
    </div>
</div>
